export default __webpack_public_path__ + "static/media/square-two.cfc5c7a1.jpg";